import { Box, Typography , Grid  } from '@mui/material'
import React  from 'react'
import RandomlyColoredAvatar from '../../../Layout/RandomlyColoredAvatar' 
import LinkButton from '../../../shared/LinkButton'
import PrimaryButton from '../../../shared/PrimaryButton'
import CustomerForm from './CustomerForm'
import { FormikProvider } from 'formik'
const SideCustomerForm = (props) => {
  return (
    <Box padding={3}>
          <Grid
                container
                spacing={2}
             alignItems="center"
             marginBottom={3} 
              >
                <Grid item>
                  <RandomlyColoredAvatar
                    name={props.formik.values.customerName}
                    size={80}
                  />
                </Grid>
                <Grid item>
                  <Typography
                    sx={{
                      color: "#04162B",
                      fontSize: "1.125rem",
                      fontWeight: 550,
                      letterSpacing: "-0.6px",
                      lineHeight: "20px",
                      marginBottom:"5px"
                    }}
                  >
                  {props.formik.values.customerName}
                  </Typography>
                  <Typography
                    sx={{
                      marginTop: "3px",
                      color: "#050D2E",
                      fontSize: ".875rem",
                      fontWeight: 400,
                      letterSpacing: "-0.47px",
                      lineHeight: "16px",
                    }}
                  >
                 {props.formik.values.AccountNo}
                  </Typography>
                </Grid>
        </Grid>

        <Grid
        container
        spacing={2}
        marginBottom={3} 
        >
<Grid item>
    <PrimaryButton onClick={() => props.CheckStatus({status:props.formik.values.status === "ACTIVE" ? "INACTIVE" : "ACTIVE",customerIds:[props.formik.values.customerId]})}>{props.formik.values.status === "ACTIVE" ? "Deactivate Customer" : "Activate Customer"}</PrimaryButton>
</Grid>
<Grid item>
<LinkButton  color={"#E6001A"} underline="none" onClick={() => props.DeleteCustomer(props.formik.values.customerId)}>Delete Customer</LinkButton>
</Grid>
        </Grid>


<Grid>
  <FormikProvider value={props.formik}>

    <CustomerForm
    formik={props.formik}
    NotificationType={props.NotificationType}
    customerType={props.customerType}
    defaultTemplate={props.defaultTemplate}
    SendingType={props.SendingType}
    Direction = {props.Direction}
    docType={props.docType}
    saftyType={props.saftyType}
    messageTypes={props.messageTypes}
    NotificationTemplates={props.NotificationTemplates}
    setTouched={props.setTouched}
    touched={props.touched}
    EditMode={true}
    Groups={props.Groups}
    setDrawer={props.setDrawer}
    />
  </FormikProvider>

</Grid>
    </Box>
  )
}

export default SideCustomerForm